import React, { useLayoutEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainMenu from './components/MainMenu';
import Footer from './components/Footer';
import Error404 from './pages/Error404';
import Home from './pages/Home';
import Team from './pages/Team';
import Activities from './pages/Activities';
import Camp from './pages/Camp';
import Cga from './pages/Cga';
import Configurator from './pages/configurator/Configurator';
import Lpd from './pages/LPD';
import Legal from './pages/Legal';

// Maps a route pathname to its `PageTitles` translation key. Any pathname not
// listed here (including "/" and the 404 catch-all) falls back to the home title.
const PAGE_TITLE_KEYS: Record<string, string> = {
  '/activities': 'activities',
  '/team': 'team',
  '/camp': 'camp',
  '/configurator': 'configurator',
  '/cga': 'cga',
  '/protection': 'protection',
  '/legal': 'legal',
};

export default function App() {
  const { t } = useTranslation('', { keyPrefix: 'PageTitles' });

  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    const titleKey = PAGE_TITLE_KEYS[location.pathname];
    document.title = titleKey
      ? `Colonie Les Eterpaz - ${t(titleKey)}`
      : `Colonie Les Eterpaz - ${t('home')} à Broc`;
  }, [location.pathname]);

  return (
    <div className="App">
      <MainMenu />

      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/team" element={<Team />} />
        <Route path="/camp" element={<Camp />} />
        {/* <Route path="/configurator" element={<ConfigInProgress />} /> */}
        <Route path="/configurator" element={<Configurator />} />
        <Route path="/cga" element={<Cga />} />
        <Route path="/protection" element={<Lpd />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/*" element={<Error404 />} />

        {/* <Route path="/mail" element={<MailTemplate />} /> */}
      </Routes>

      <Footer contactFormUrl="/configurator" />
    </div>
  );
}
